const info = {
  ZH: { //中文翻译
    contactPersonOfOurCompany:"本企业联系人",
    suplierContacts:"供应商联系人",
    setSuplierContactsTips:"该联系人未在本企业联系人列表,继续将默认添加到联系人列表，是否继续？",
    supplierData: "\u672C\u4F01\u4E1A\u4FE1\u606F",
    mdsInfo: " \u6750\u6599\u6570\u636E\u8868",
    mdsStatus1: " \u72B6\u6001\uFF1A\u5728\u7F16\u8F91\u4E2D",
    mdsStatus2: " \u72B6\u6001\uFF1A\u5185\u90E8\u53D1\u5E03",
    mdsStatus3: " \u72B6\u6001\uFF1A\u5DF2\u53D1\u9001",
    mdsStatus4: " \u72B6\u6001\uFF1A\u5DF2\u63D0\u4EA4",
    mdsStatus5: " \u72B6\u6001\uFF1A\u5DF2\u53D1\u5E03",
    mdsIdAndVer: "ID/\u7248\u672C\uFF1A",
    modelname: " \u672C\u4F01\u4E1A\u4FE1\u606F",
    modelpath1: " \u67E5\u627E",
    modelpath2: " \u7F16\u8F91",
    modelpath3: " \u6750\u6599\u6570\u636E\u8868",
    modelpath4: " \u672C\u4F01\u4E1A\u4FE1\u606F",
    modelpathflag: " >>",
    enterprise: "\u4F01\u4E1A\u540D\u79F0\uFF1A",
    duns: "DUNS\u7F16\u53F7\uFF1A",
    address: "\u5730\u5740\uFF1A",
    country: "国家/地区：",
    orgId: "\u90E8\u95E8\uFF1A",
    contactPerson: "\u8054\u7CFB\u4EBA\uFF1A",
    mdsCreator: "MDS\u521B\u5EFA\u4EBA\uFF1A",
    mdsContactPerson: "MDS\u8054\u7CFB\u4EBA\uFF1A",
    managerList: "\u4F01\u4E1A\u7BA1\u7406\u5458\u5217\u8868\uFF1A",
    no: "\u5E8F\u53F7",
    name: "\u59D3\u540D",
    name1: "\u59D3\u540D\uFF1A",
    telephoneNo: "\u7535\u8BDD\u53F7\u7801",
    addPerson: "\u8BF7\u6DFB\u52A0MDS\u8054\u7CFB\u4EBA\!",
    addPersonDep: "请添加部门和联系人！",
    addDep: "\u8BF7\u6DFB\u52A0\u90E8\u95E8\uFF01",
    select: "----\u8BF7\u9009\u62E9----",
    telephoneNo1: "\u7535\u8BDD\u53F7\u7801\uFF1A",
    faxNo: "\u4F20\u771F\u53F7\u7801",
    faxNo1: "\u4F20\u771F\u53F7\u7801\uFF1A",
    email: "\u7535\u5B50\u90AE\u7BB1",
    email1: "\u7535\u5B50\u90AE\u7BB1\uFF1A",
    active: "\u6709\u6548\u6027\uFF1A",
    valid: "\u6709\u6548",
    invalid: "\u65E0\u6548",
    return: "\u4E0A\u4E00\u6B65",
    save: "\u4FDD\u5B58",
    next: "\u4E0B\u4E00\u6B65",
    backToResult: "\u67E5\u627E\u7ED3\u679C",
    returnMds: "\u8FD4\u56DEMDS",
    errorMessage: "MDS\u672A\u4FDD\u5B58\uFF0C\u8BF7\u5148\u4FDD\u5B58MDS\u4FE1\u606F\uFF01",
    message: " \u60A8\u8FD8\u6CA1\u6709\u4FDD\u5B58\u6570\u636E\uFF0C\u662F\u5426\u5148\u4FDD\u5B58\uFF0C\u7136\u540E\u8FDB\u5165\u4E0B\u4E00\u9875\u9762?",
    mdsContactPersonMsg: "\u60A8\u9009\u62E9\u7684\u8054\u7CFB\u4EBA\u4FE1\u606F\uFF0C\u5C06\u4F1A\u51FA\u73B0\u5728\u60A8\u53D1\u9001\u5BA2\u6237\u7684 MDS \u6570\u636E\u8054\u7CFB\u4EBA\u5217\u8868\u4E0A\u3002",
  },
  EN: { //英文翻译
    contactPersonOfOurCompany:"Contact person of our company",
    suplierContacts:"Supplier Contact",
    setSuplierContactsTips:"This contact is not in our company's contact list. Continue to add it to the contact list by default. Do you want to continue?",
    supplierData: "	Supplier Information",
    addPersonDep: "Please add department and contacts\!",
    mdsInfo: "MDS",
    mdsStatus1: "status\uFF1AEdit mode",
    mdsStatus2: "status\uFF1Ainternally released",
    mdsStatus3: "status\uFF1ASent",
    mdsStatus4: "status\uFF1Aproposed",
    mdsStatus5: "status\uFF1APublished",
    mdsIdAndVer: "ID/Version\uFF1A",
    modelname: "	supplier information",
    modelpath1: "	Search",
    modelpath2: "	Edit",
    modelpath3: "	MDS",
    modelpath4: "	supplier data",
    modelpathflag: "	 >>",
    enterprise: "Enterprise Name\:",
    duns: "	DUNS No.:",
    address: "	Address:",
    country: "Country/Region:",
    orgId: "	Organization:",
    contactPerson: "	Contact person:",
    mdsContactPerson: "MDS Contact person",
    telephoneNo: "Tel No.",
    telephoneNo1: "Tel No\uFF1A",
    faxNo: "	Fax No.",
    faxNo1: "Fax No\uFF1A",
    email: "E-mail",
    email1: "E-mail\uFF1A",
    active: "	Validity:",
    valid: "	Valid",
    invalid: "	Invalid",
    managerList: "Enterprise administrators list\uFF1A",
    no: "No",
    name: "Name",
    name1: "Name\uFF1A",
    mdsCreator: "MDS Creator\uFF1A",
    return: "	Back",
    save: "	Save",
    next: "	Next",
    backToResult: "SearchResult",
    returnMds: "Return",
    errorMessage: "	MDS data have not been saved. Please save MDS data first!",
    message: "You haven't saved the data yet,do you really want to save it and then jump to the next page?",
    addPerson: "Please add contanctPerson\!",
    addDep: "Please add Department\!",
    select: "----please select----",
    mdsContactPersonMsg: "The contact information you select will appear on the MDS data contact list that you send to the client.",

  }
}
export default info //需要暴露出去
